module.exports = __webpack_public_path__ + "assets/img/teacher (38).0c6c6282.png";